var map = {
	"./icon-doc.png": 434,
	"./icon-docx.png": 435,
	"./icon-pdf.png": 440,
	"./icon-ppt.png": 438,
	"./icon-pptx.png": 439,
	"./icon-txt.png": 441,
	"./icon-xls.png": 436,
	"./icon-xlsx.png": 437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3579;